import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CancelServiceTicket Input Action
 */
export class CancelServiceTicketInput implements Msdyn365.IActionInput {
    public ticketId: string;
    constructor(ticketId: string) {
        this.ticketId = ticketId;
    }

    public getCacheKey = () => `CancelServiceTicketKey`;
    public getCacheObjectType = () => 'CancelServiceTicket';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface ICancelServiceTicketData {}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CancelServiceTicketInput('');
};

async function action(input: CancelServiceTicketInput, ctx: Msdyn365.IActionContext): Promise<ICancelServiceTicketData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const requestBody = { ticketId: input.ticketId };

    const response = await Msdyn365.sendRequest<ICancelServiceTicketData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/CancelServiceTicket`,
        'post',
        requestBody,
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`,
                timeout: '30000'
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICancelServiceTicketData>>action,
    id: 'CancelServiceTicket',
    input: createInput
});
